import { render, staticRenderFns } from "./MercapromoCard.vue?vue&type=template&id=57311c28&scoped=true"
import script from "./MercapromoCard.vue?vue&type=script&lang=js"
export * from "./MercapromoCard.vue?vue&type=script&lang=js"
import style0 from "./MercapromoCard.vue?vue&type=style&index=0&id=57311c28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57311c28",
  null
  
)

export default component.exports